import { Component } from 'react';
import Raven from 'raven-js';
import { ResultPromiseContext } from 'forms-ai-lib/internal/providers/ResultPromiseContext';
export class ResultPromiseErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    const context = this.context;
    context.resultPromiseRef.current.reject(error);
    Raven.captureException(error);
  }
  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
ResultPromiseErrorBoundary.contextType = ResultPromiseContext;